import {
  logWorkspace,
  requireUser,
  serviceState,
  updateUserStatus,
} from '../..';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import appManager from '@app/appManager';
import {
  ServiceSessionEventType,
  ServiceSessionUserEvent,
} from '../../types/ServiceEvents';

/**
 * The delivered event indicates that a session was successfully
 * delivered to a recipient and is now being handled.
 * @param event
 */
async function handleAgentSessionDelivered(
  event: Telecom.AgentSessionDeliveredEvent,
) {
  const user = await requireUser(event.agentId);
  logWorkspace('service:agent:session_delivered:' + user?.name, event);

  user.available = event.available;
  user.availabilityState = 'On-A-Call';
  user.capacity = 0;
  user.stats = userStatsFromAgentStats(event.stats);

  // update our status. can't change status while offered a call
  updateUserStatus(user.id, undefined, false);

  appManager.events.emit<ServiceSessionUserEvent>(
    ServiceSessionEventType.DELIVERED,
    {
      sessionId: event.conversationId,
      sessionSid: event.conversationSid,
      agentId: event.agentId,
      userId: user.id,
    },
  );

  const session = serviceState.sessions[event.conversationId];
  if (!session) {
    console.error('session not found', event.conversationId);
    return;
  }

  session.agentId = event.agentId;
  session.createdAt = Date.now();
  session.queueId = event.queueId;
  session.queueName = event.queueName;
}

export default handleAgentSessionDelivered;
